module.exports = __webpack_public_path__ + "img/speaker-NinoGordeladze-imgs.d92dce5b.png";